const setErrorOnInternalServerAction = ({ commit }, payload) => {
  commit('setErrorOnInternalServer', payload)
}

export default {
  setErrorOnInternalServerAction,
}
